module.exports = __webpack_public_path__ + "static/media/img-banner-in-sample.22434a24.svg";